import React from 'react'
import Spacer from '../../../components/Spacer';
import Banner from '../../../components/Banner';
import BannerInfo from './BannerInfo';


function OrganitationP() {
  return (
    <>
    <Banner titleSection={'ORGANISMOS PARTICIPANTES'} linkName={'Inicio'} nameSection={'Organizmos Participantes'} />
    <Spacer/>
    <BannerInfo/>
    <Spacer/>
    </>
  )
}

export default OrganitationP